import React, { Component } from 'react'
import Tag from '@bt-react/components/Tag'
import InputSourceSelector, { Option } from '@bt-react/components/InputSourceSelector'
import Icon, { IconType } from '@bt-react/components/Icon'
import { DialInRegionSelectorProps, DialInRegionSelectorState } from './types'
import isEqual from 'lodash/isEqual'
import style from './DialInRegionSelector.module.scss'
import { DialInPhoneNumberRecord } from '../../services/apiGateway/apiGatewayTypes'
import DialInSettingsStatus from '../DialInSettingsStatus'
import classnames from 'classnames'

class DialInRegionSelector extends Component<DialInRegionSelectorProps, DialInRegionSelectorState> {

  state: DialInRegionSelectorState = {
    dialInOptions: []
  }

  componentDidMount () {

    if (this.props.phoneNumbers.length === 0) this.fetchDialInData()
    else this.setOptions(this.props.phoneNumbers)

  }

  componentDidUpdate (prevProps: DialInRegionSelectorProps) {

    if (!isEqual(prevProps.phoneNumbers, this.props.phoneNumbers)) this.setOptions(this.props.phoneNumbers)

  }

  fetchDialInData = () => {

    this.props.fetchDialInCode(this.props.roomname, this.props.participant)
    this.props.fetchDialInPhoneNumbers(this.props.roomname)

  }

  formatOptionLabel = (entry: DialInPhoneNumberRecord): string => `${entry.countryCode} - ${entry.phoneNumber}`

  fetchSelectedEntry = (): Option | undefined => this.state.dialInOptions.find(entry => entry.value === this.props.selectedPhoneNumber)

  setOptions (phoneNumbers: DialInRegionSelectorProps['phoneNumbers']) {

    this.setState({
      dialInOptions: phoneNumbers.map(entry => ({
        label: this.formatOptionLabel(entry),
        value: entry.phoneNumber
      }))
    })

  }

  onDialInOptionChange = (selectedOption) => {

    this.props.setSelectedPhoneNumber(selectedOption.value)

  }

  render () {

    return <div
      className={classnames(style['dial-in-region'], {
        [style['dial-in-region--no-label']]: !this.props.label
      })}
      data-bdd='dial-in-selector'
    >
      <InputSourceSelector
        sourceType='dialIn'
        selectedOption={this.fetchSelectedEntry()}
        label={this.props.label}
        onOptionChange={this.onDialInOptionChange}
        switchComponent={this.props.switchComponent}
        options={this.state.dialInOptions}
        classNames={style['dial-in-selector']}
        previewComponent={
          <div>
            <DialInSettingsStatus />
          </div>
        }
      />
      <div className={style['dial-in-region-details']}>
        <span>Dial in:</span>
        <span className={style['dial-in-region-value']}>
          {
            this.props.isFetchingPhoneNumbers
              ? <Icon name={IconType.iconName.spinner} />
              : this.props.selectedPhoneNumber
          }
        </span>
        <span>Participant ID:</span>
        <div className={style['dial-in-region-value']} >
          <span className={style['dial-in-region-value-padding']} >
            {
              this.props.isFetchingParticipantCode
                ? <Icon name={IconType.iconName.spinner} />
                : this.props.code
            }
          </span>
          {
            this.props.code === null || this.props.isFetchingParticipantCode
              ? null
              : <Tag
                isOpen={true}
                content={<span>Your participant ID is unique to you.<br/>Do not share with other presenters.</span>}
                position='right'
              />
          }
        </div>
      </div>
    </div>

  }

}

export default DialInRegionSelector
